import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {AgencyProfileContent} from "./AgencyProfileContent";

export class AgencyProfile extends Component {
    render() {

        return (
            <div className="app-content">
                <LayoutSidebar />
                <AgencyProfileContent />
            </div>
        )
    }
}

